var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { ExpanderColumn, EXPANDER_CELL_ID } from '../columns';
export var useExpanderCell = function (subComponent, expanderCell, isRowDisabled) { return function (hooks) {
    if (!subComponent) {
        return;
    }
    hooks.allColumns.push(function (columns) {
        var hasExpanderColumn = columns.find(function (c) { return c.id === EXPANDER_CELL_ID; });
        if (hasExpanderColumn) {
            return columns;
        }
        var expanderColumn = ExpanderColumn({
            subComponent: subComponent,
            isDisabled: isRowDisabled,
        });
        return __spreadArray([
            __assign(__assign({}, expanderColumn), { Cell: expanderCell
                    ? function (cellProps) { return React.createElement(React.Fragment, null, expanderCell(cellProps)); }
                    : expanderColumn.Cell })
        ], columns, true);
    });
}; };
